// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function EyeClosedBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M29.302 20.25a1.504 1.504 0 0 1-2.604 1.5l-2.108-3.688a15.897 15.897 0 0 1-3.771 1.733l.66 3.955a1.5 1.5 0 0 1-1.483 1.746 1.5 1.5 0 0 1-1.477-1.25l-.644-3.85a17.054 17.054 0 0 1-3.758 0l-.637 3.854a1.501 1.501 0 0 1-2.96-.5l.661-3.965a15.897 15.897 0 0 1-3.771-1.733L5.302 21.75a1.503 1.503 0 0 1-2.605-1.5L5 16.231a19.972 19.972 0 0 1-2.164-2.289 1.5 1.5 0 0 1 2.331-1.885C7.172 14.54 10.68 17.5 16 17.5s8.827-2.96 10.832-5.443a1.5 1.5 0 0 1 2.334 1.886A19.98 19.98 0 0 1 27 16.23l2.302 4.019Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
